import { Col, Form, Input } from "reactstrap";
import { useAppDispatch } from "../../../../../reduxToolkit/hooks";
import { Search } from "../../../../../constants";
import { filterSearchBy } from "../../../../../reduxToolkit/reducers/eCommerce/filterSlice";

// This component displays a search input field with an icon that dispatches a search filter action on input change.
const SearchBar = () => {
  const dispatch = useAppDispatch();

  return (
    <Col md="9" sm="12">
      <Form>
        <div className="form-group m-0">
          <Input type="search" placeholder={Search} onChange={(e) => dispatch(filterSearchBy(e.target.value))} />
          <i className="fa fa-search"></i>
        </div>
      </Form>
    </Col>
  );
};
export default SearchBar;